import { render, staticRenderFns } from "./JobInvitations.vue?vue&type=template&id=21ce7d49&"
import script from "./JobInvitations.vue?vue&type=script&lang=js&"
export * from "./JobInvitations.vue?vue&type=script&lang=js&"
import style0 from "./JobInvitations.vue?vue&type=style&index=0&id=21ce7d49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports